<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-header">
        <div class="logo">
          <span class="logo-icon">🧠</span>
          <span class="logo-text">韦小布AI</span>
        </div>
        <h2>后台管理登录</h2>
        <p>请输入您的账号和密码</p>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-position="top">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login" :loading="loading" class="login-button">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          // 调用后端API登录
          this.$axios.post('/api/admin/login', this.loginForm)
            .then((response) => {
              // 登录成功后存储token并跳转到后台管理页面
              if (response.data && response.data.token) {
                localStorage.setItem('token', response.data.token)
              } else {
                localStorage.setItem('token', 'fake-token')
              }
              localStorage.setItem('userInfo', JSON.stringify(response.data.data || { id: 1, email: 'admin' }))
              this.$message.success('登录成功')
              this.$router.push('/admin')
              this.loading = false
            })
            .catch((error) => {
              console.error('登录错误详情:', error)
              const errorMsg = error.response ? error.response.data.detail || error.response.data.message || '登录失败' : '网络请求失败，请检查后端服务是否运行'
              this.$message.error(errorMsg)
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>



<style scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #0b0e17 0%, #1a1e2d 100%);
  padding: 40px;
  box-sizing: border-box;
}

.login-form {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 60px 40px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(15px);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.login-form:hover {
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.5);
  transform: translateY(-5px);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 24px;
  font-weight: 600;
  color: #00e6ac;
  margin-bottom: 20px;
}

.logo-icon {
  font-size: 28px;
}

.login-header h2 {
  font-size: 28px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 600;
}

.login-header p {
  color: #aaa;
  font-size: 16px;
}

.el-form {
  width: 100%;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  color: #aaa;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.el-input {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.el-input:hover {
  border-color: rgba(0, 230, 172, 0.3);
}

.el-input:focus-within {
  border-color: #00e6ac;
  box-shadow: 0 0 0 2px rgba(0, 230, 172, 0.2);
}

.el-input__inner {
  color: #fff;
  font-size: 16px;
  padding: 14px 16px;
}

.el-input__inner::placeholder {
  color: #666;
}

.login-button {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  border: none;
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  border-radius: 10px;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-button:hover {
  background: linear-gradient(135deg, #00cc99, #00b386);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 230, 172, 0.3);
}

.login-button:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .login-container {
    padding: 20px;
  }
  
  .login-form {
    padding: 40px 30px;
    max-width: 100%;
  }
  
  .login-header h2 {
    font-size: 24px;
  }
  
  .login-header p {
    font-size: 14px;
  }
  
  .el-input__inner {
    font-size: 14px;
    padding: 12px 14px;
  }
  
  .login-button {
    height: 44px;
    font-size: 14px;
  }
}
</style>